module.exports = __webpack_public_path__ + "static/media/org_mobile.e95b25bd.svg";